import React, {Component} from 'react';
import '../../App.css';
// import SSOLogin from '../../SSOLogin';
import TechPrimersContent from '../TechPrimersContent';
// import { msalApp } from '../../utils/MSUtils';
// import { msalConfig } from "../../authConfig";

function FoundationTechPrimers() {
    return (
      <>
          <TechPrimersContent />
      </>
    )
  }

export default FoundationTechPrimers;